module.exports = __webpack_public_path__ + "img/si.d415adba.svg";